import React from 'react';
import AllProductsGrid from '../components/products/AllProductsGrid';

const AllProducts = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-catalina-blue to-san-marino text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">All Products</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Explore our complete range of industrial material handling equipment and solutions
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <AllProductsGrid />
    </div>
  );
};

export default AllProducts;